const dealerCodeTypes = [
    "activation",
    "acura",
    "adp-sonic",
    "adw",
    "affiliate_promotions",
    "ais",
    "an-hyperion",
    "aoa",
    "aoa-ddc",
    "aoa-export",
    "aoaddc-cdc",
    "aoadistrict",
    "ar",
    "arca",
    "at-kbb",
    "au",
    "audicanada",
    "autocheck",
    "autonation",
    "auxiliary_options",
    "avis",
    "bmw",
    "bmw-export",
    "bmw_cpo",
    "bmw_cpo_tier2",
    "bmw_location",
    "bmw_region",
    "boa",
    "cci",
    "cllc",
    "cllc-ddc",
    "cllcbc",
    "cllcdaachrysler",
    "cllcdaajeep",
    "cllcdistrict",
    "cllcpr",
    "contact-at-once",
    "dealer-socket",
    "dealertrack-post",
    "dmi",
    "driverside",
    "dt-dr-profile",
    "dtdms",
    "dtid",
    "dtid-bak",
    "echoparkmarketid",
    "echoparkstoreid",
    "elead",
    "excluded_jeep_accounts",
    "fca_vin_incentives",
    "fcamx",
    "fd",
    "fd-appcontext",
    "fdca",
    "fdregion",
    "fiat",
    "fiat-ddc",
    "fiat-temp",
    "fiatca",
    "fiatpr",
    "flowautomotive",
    "fmc",
    "fmc-ddc",
    "fordregion",
    "gcb-mx",
    "genesis",
    "genesis_adi",
    "genesis_district",
    "genesis_region",
    "genesisdwcp",
    "gm",
    "gm-acc-ca",
    "gm-area-group",
    "gm-backlink-ca",
    "gm-carbravo",
    "gm-chipered-ca",
    "gm-dealer-ca",
    "gm-dma",
    "gm-export",
    "gm-homenet",
    "gm-rooftop",
    "gmca",
    "gmcabac",
    "gsm",
    "gst",
    "hertz",
    "hertzrouteone",
    "hertzrouteonefinance",
    "holman",
    "honda",
    "hondaadvdealer",
    "hondaoem",
    "hooklogic",
    "hyundai",
    "hyundai_adi",
    "hyundai_district",
    "hyundai_dma_cd",
    "hyundai_region",
    "hyundaictb",
    "hyundaidwcp",
    "infiniti",
    "jag",
    "jag-ddc",
    "jag-export",
    "jeep",
    "kia",
    "kia-reporting",
    "kiadmg",
    "kiadmggroup",
    "langley",
    "lender",
    "lexus",
    "lexus-export",
    "lexus-geo-key",
    "lexus-lda",
    "lhm",
    "lithia",
    "lr",
    "lr-export",
    "maserati",
    "mazda",
    "mbz",
    "mercedes-export",
    "mini",
    "mini-export",
    "mitsubishi",
    "mitsubishi-export",
    "mitsuca",
    "mitsuud",
    "modernautomotive",
    "nci",
    "nic",
    "nissan",
    "nissanleads",
    "nissanoem",
    "nissanservice",
    "nna",
    "offerlogix",
    "penairfcu",
    "porsche",
    "ram",
    "rmau",
    "route-one",
    "ryantech-sonic",
    "saab",
    "saab-ddc",
    "scion",
    "scion_region",
    "sdis_lexus",
    "sdis_toyota",
    "simsmarketid",
    "simsstoreid",
    "sne",
    "snedistrict",
    "sneregion",
    "soa",
    "soa-ddc",
    "soa-mtl",
    "soadistrict",
    "soaregion",
    "soazone",
    "sonic",
    "subaru-export",
    "suburban",
    "suzuki",
    "tc",
    "tcre-agent",
    "tcre-broker",
    "tcshortcode",
    "techsupptype",
    "techsupptypek",
    "toyota",
    "toyota_bat",
    "toyota_pooling",
    "toyota_region",
    "toyota_sd",
    "toyota_smartpath",
    "toyota_tcom",
    "toyota_tda",
    "trademotion",
    "unique_svoc_to_sa",
    "vcna",
    "vinsolutions-ddc",
    "volvo",
    "volvo-ddc",
    "volvo-partner-id",
    "vw",
    "vw-daa",
    "vw-export",
    "vw-oem",
    "w2w"
];

export default dealerCodeTypes;